var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.036,
    height: 133.242,
    viewBox: "0 0 128.036 133.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106120",
    "data-name": "Group 106120",
    transform: "translate(0 -0.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exit-door",
    transform: "translate(0 0.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69820",
    "data-name": "Path 69820",
    d: "M106.767,8.368,65.129.04a2.082,2.082,0,0,0-2.491,2.041V8.327H23.082A2.081,2.081,0,0,0,21,10.409V22.9a2.082,2.082,0,0,0,4.164,0V12.491H62.638v4.164H31.41a2.081,2.081,0,0,0-2.082,2.082v6.246a2.082,2.082,0,1,0,4.164,0V20.819H62.638v108.26H31.41a2.082,2.082,0,0,0,0,4.164h74.949a2.081,2.081,0,0,0,2.082-2.082V10.409A2.083,2.083,0,0,0,106.767,8.368Zm-2.491,120.71H66.8V4.621l37.474,7.5Z",
    transform: "translate(19.596 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69821",
    "data-name": "Path 69821",
    d: "M47.082,43.491a2.081,2.081,0,0,0,2.082-2.082V33.082a2.082,2.082,0,0,0-4.164,0V41.41A2.081,2.081,0,0,0,47.082,43.491Z",
    transform: "translate(45.562 33.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69822",
    "data-name": "Path 69822",
    d: "M26.41,34.819A10.41,10.41,0,1,0,16,24.41,10.422,10.422,0,0,0,26.41,34.819Zm0-16.655a6.246,6.246,0,1,1-6.246,6.246A6.253,6.253,0,0,1,26.41,18.164Z",
    transform: "translate(14.186 15.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69823",
    "data-name": "Path 69823",
    d: "M48.47,66.6l-10.16-7.248L41.1,50.976l2.194,2.632a8.362,8.362,0,0,0,4.6,2.795l11.518,2.562a6.31,6.31,0,0,0,3.355-12.149l-8.842-2.954-6.11-10.71a14.412,14.412,0,0,0-5.983-5.643l-1.907-.964a12.442,12.442,0,0,0-12.278.622c-.039.025-.07.059-.109.084L13.3,30.417a8.365,8.365,0,0,0-5.624,4.4L2.184,45.742a6.276,6.276,0,0,0,3.259,8.675,6.168,6.168,0,0,0,2.364.475,6.358,6.358,0,0,0,5.378-3.038L18.4,43.306l1.61-.286L16.581,56.081a10.325,10.325,0,0,0,.189,5.848L6.639,96.7a7.236,7.236,0,0,0,6.935,9.26,7.2,7.2,0,0,0,6.75-4.617l10.49-26.968,4.952,3.464L34.172,98.679a6.743,6.743,0,0,0,13.372,1.649l4.29-25.565a8.3,8.3,0,0,0-3.363-8.16ZM16.75,39.371a2.08,2.08,0,0,0-1.413.965l-5.7,9.345a2.074,2.074,0,0,1-2.621.879A2.111,2.111,0,0,1,5.8,49.332a2.087,2.087,0,0,1,.1-1.71l5.5-10.926a4.2,4.2,0,0,1,2.818-2.217l8.764-1.95a12.574,12.574,0,0,0-.735,2.011l-1.063,4.044-4.429.787Zm-.305,60.462a3.068,3.068,0,0,1-5.931-1.1,3.1,3.1,0,0,1,.124-.874L19.764,66.54a10.52,10.52,0,0,0,.9.737L27.3,71.918,16.445,99.833ZM47.726,74.074l-4.29,25.568a2.572,2.572,0,0,1-2.547,2.153,2.539,2.539,0,0,1-1.883-.824A2.582,2.582,0,0,1,38.323,99l1.686-22.027a2.078,2.078,0,0,0-.882-1.864L23.059,63.866a6.3,6.3,0,0,1-2.454-6.72L24.877,40.89l.013-.05L26.267,35.6a8.363,8.363,0,0,1,8.059-6.218,8.371,8.371,0,0,1,3.729.883l1.9.958a10.245,10.245,0,0,1,4.251,4l6.5,11.388a2.074,2.074,0,0,0,1.147.942L61.46,50.77A2.146,2.146,0,0,1,60.308,54.9L48.782,52.335a4.178,4.178,0,0,1-2.3-1.4l-4.56-5.471c-.014-.018-.029-.036-.045-.053l-4.43-5.322a2.082,2.082,0,0,0-3.2,2.663l3.712,4.461L33.875,59.5a2.082,2.082,0,0,0,.767,2.352l11.4,8.135a4.208,4.208,0,0,1,1.683,4.087Z",
    transform: "translate(-1.501 27.283)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.df8780b728b65bc4e345b93d894c0d0f.svg";
export { ForwardRef as ReactComponent };